export enum FileType {
  ENDPOINT = 'ENDPOINT',
  QUEUE = 'QUEUE',
}
